import { ABORT_ERROR_NAMES } from "@/constants/abortErrors";

// posthog-js runs its DOMException coercer before its Error coercer, so every DOMException — which is what fetch, AbortController and media play() mint — is serialized as type "DOMException" with the abort name folded into value ("AbortError: The user aborted a request."). Matching on type alone would therefore catch only axios CanceledError.
const DOM_EXCEPTION_TYPE = "DOMException";

// True when a serialized PostHog exception describes an intentionally cancelled request. Counterpart to isAbortError, which classifies live errors; this one reads the wire shape that before_send receives.
export const isSerializedAbortException = ({
  type,
  value,
}: {
  type: string | undefined;
  value: string | undefined;
}): boolean => {
  if (type === undefined) {
    return false;
  }

  if (type !== DOM_EXCEPTION_TYPE) {
    return ABORT_ERROR_NAMES.includes(type);
  }

  if (value === undefined) {
    return false;
  }

  return ABORT_ERROR_NAMES.some(
    (abortErrorName) =>
      value === abortErrorName || value.startsWith(`${abortErrorName}: `)
  );
};
